import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardFooter, CardTitle, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import { updateConfigInit as onUpdateConfigInit } from "../../store/Config/actions"
import { useActiveCityhall } from "../../context/ActiveCityhallContext"
import InputCustom from "components/Common/InputCustom";

const FormCityhallConfProperty = ({edit=false}) => {

    const dispatch = useDispatch()
     const { cityHall, period } = useSelector(state => ({
        cityHall: state.ConfigInit.cityHall,
        period: state.ConfigInit.period
    }));

    const { activeCityhall } = useActiveCityhall();
    const [periodL, setPeriodL] = useState(null)


    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: cityHall!==null && edit ? cityHall.id:null,
            name: cityHall!==null && edit ? cityHall.name:"",
            rfc: cityHall!==null && edit ? cityHall.rfc:"",
            yearIni: Array.isArray(period) && period.length>0 ? period[0]:"",
            yearEnd:(Array.isArray(period) && period.length>0) ? period[1]:"",
            acronym: cityHall!==null && edit ? cityHall.acronym:"",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Ingresa el nombre del municipio"),
            rfc: Yup.string().required("Ingresa el RFC del municipio"),
            yearIni: Yup.string().required("Ingresa el año inicial del periodo"),
            yearEnd: Yup.string().required("Ingresa el año final del periodo"),
            acronym: Yup.string().required("Ingresa el acronimo del municipio"),
        }),
        onSubmit: (values) => {
          dispatch(onUpdateConfigInit(values))
        },
    });   

    
    return (
        <>
        <Form onSubmit={(e)=>{
            e.preventDefault();
            validation.handleSubmit();
        }}>
            <Card>
                <CardBody>
                  <CardTitle>Configuración del Municipio</CardTitle>
                  <h6 className="text-success mt-4">
                  </h6>
                  <Form>
                    <Row>
                        <Col sm="12">
                            <Row>
                                <Col sm="12">
                                <InputCustom
                                    lblInput="Nombre del Municipio"
                                    inputName="name"
                                    inputType="text"
                                    inputPlaceholder="Ingrese el nombre"
                                    validation={validation}
                                />
                                </Col>
                            </Row>
                        </Col>
                      <Col sm="12">
                        <Row>
                          <Col sm="12">
                            <InputCustom
                              lblInput="RFC del Municipio"
                              inputName="rfc"
                              inputType="text"
                              inputPlaceholder="Ingrese el RFC"
                              validation={validation}
                            />
                          </Col>
                        </Row>
                      </Col>
                        <Col sm="6" >
                        <Row>
                            <Col sm="6">
                              <InputCustom
                                lblInput="Acrónimo del Municipio"
                                inputName="acronym"
                                inputType="text"
                                inputPlaceholder="Ingrese el acronimo"
                                validation={validation}
                              />
                            </Col>
                            </Row>
                        </Col>

                        <Col sm="6" >
                        <Row>
                            <Col sm="6">
                                <InputCustom
                                    lblInput="Año Inicial del Periodo"
                                    inputName="yearIni"
                                    inputType="text"
                                    inputPlaceholder="Ingrese el año inicial"
                                    validation={validation} 
                                />  
                            </Col>

                            <Col sm="6">
                                <InputCustom
                                    lblInput="Año Final del Periodo"
                                    inputName="yearEnd"
                                    inputType="text"
                                    inputPlaceholder="Ingrese el año final"
                                    validation={validation} 
                                />  
                            </Col>
                        </Row>
                        </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter>
                        <div className="text-end mb-3">
                            <Button type="submit" color="primary" className="btn ">
                                Guardar Cambios
                            </Button>
                        </div>
                </CardFooter>
              </Card>
            </Form>
        </>
    )
}

export default FormCityhallConfProperty